<body #body class="isOpen">
  <nav #sidebar class="sidebar">
      <header class="p-2">
          <div class="image-fgc">
              <span class="image">
                  <img src="../../../../assets/logos/Icone-FGC.ico" alt="">
              </span>
            </div>
          <span class="bold">Portal Investidor</span>
      </header>
      <div class="menu-bar p-2  ">
        <div class="menu mt-4">
          <ul class="menu-links mb-5">
            <li *ngFor="let item of menuItems" class="mt-4" [class.selected]="item.urlPath === rotaAtual">
              <a data-testid="botoes-menus" (click)="goToDetail(item.urlPath)">
                <i [class]="item.icon"></i>
                <span class="text nav-text">{{item.nameItem}}</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
  </nav>
  <div class="topbar">
    <div class="content-left">
      <span class="usuario">Olá, {{usuario}}!</span>
      <span class="mensagem">{{mensagem}}</span>
    </div>
    <div class="content-right">
      <a (click)="resetStorage()">
        <i class="fas fa-sign-out-alt icon"></i>
        <span class="text nav-text">Sair</span>
      </a>
    </div>
  </div>
<div class="container-fluid px-5 py-3">
  <ng-content></ng-content>
  </div>
</body>

